// @core/api/endpoints/team/resume_role_schedule.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ResumeRoleScheduleRequest,
} from '../../../types/team';

const BASE_PATH = '/team';

/**
 * Resume role schedule
 * Performs resume operation on role schedule.
 */
export async function ResumeRoleSchedule(
  team_id: string,
  schedule_id: string,
  data: ResumeRoleScheduleRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:team_id/schedules/:schedule_id/resume`;
  requestPath = requestPath.replace(':team_id', encodeURIComponent(team_id));
  requestPath = requestPath.replace(':schedule_id', encodeURIComponent(schedule_id));
  const requestOptions = options;
  return client.post<Response>(requestPath, data, requestOptions);
}
